import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { routeConfig } from "./routes";

import {
  vsComponentName as ContactBookComponentName,
  ContactBookComponentOptions,
} from "./views/grid";

import {
  vsName as ContactBookDetailComponentName,
  contactBookDetailComponentOptions,
} from "./views/info";

import {
  vsComponentName as ContactBookFormComponentName,
  ContactBookFormComponentOptions,
} from "./views/edit";

export const vsName = "SlotTrak.ContactBook";

angular
  .module(vsName, [uiRouter])
  .config(routeConfig)
  .component(
    ContactBookComponentName,
    ContactBookComponentOptions
  )
  .component(
    ContactBookDetailComponentName,
    contactBookDetailComponentOptions
  )
  .component(
    ContactBookFormComponentName,
    ContactBookFormComponentOptions
  )
export default vsName; 
